import { render, staticRenderFns } from "./k-site-header.vue?vue&type=template&id=e8af77fe&lang=pug&"
import script from "./k-site-header.vue?vue&type=script&lang=js&"
export * from "./k-site-header.vue?vue&type=script&lang=js&"
import style0 from "./k-site-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8af77fe')) {
      api.createRecord('e8af77fe', component.options)
    } else {
      api.reload('e8af77fe', component.options)
    }
    module.hot.accept("./k-site-header.vue?vue&type=template&id=e8af77fe&lang=pug&", function () {
      api.rerender('e8af77fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-site-header.vue"
export default component.exports